import React from 'react'
import styled from 'styled-components'
import Input from '@material-ui/core/Input'


const InputBlock = styled(Input)`
    &&{
        width: 2rem;
        margin-right: 0.5rem;
        border-radius: 0.4rem;
    }
`

const CheckMark = ({sizePx = "24", viewBox = "0 0 24 24", fill = "#7DDEBD"}) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={sizePx} 
        height={sizePx} 
        viewBox={viewBox}
        fill={fill}
    >
        <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/>
    </svg>
)

const XMark = ({sizePx = "24", viewBox = "0 0 24 24", fill = "#d62728"}) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={sizePx} 
        height={sizePx} 
        viewBox={viewBox}
        fill={fill}
        style={{overflow: 'auto'}}
    >
    <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
    </svg>
)

export {
    CheckMark,
    XMark,
    InputBlock
}
